import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import Input from "@material-ui/core/Input";
import Paper from "@material-ui/core/Paper";

import RankingComponent from "./RankingComponent";
import BestAction from "./BestAction";
import Feedback from "./Feedback";

const colorRange = [
  "rgba(252,87,122,0.8)",
  "rgba(66,80,251,0.8)",
  "rgba(0,170,255,0.8)",
  "#FF9F40",
  "#FFC233"
];

const getBestComments = allActions => {
  const result = [];
  const cleanActions = allActions.filter(el => {
    return el.donePercentage > 0;
  });
  const ranked = cleanActions.sort((a, b) => b.rating - a.rating);
  let i = 0;
  while (result.length < 4 && i < ranked.length) {
    if (ranked[i].comment) {
      // result.push(ranked[i]);
      result.push(ranked[i].comment);
    }
    i++;
  }

  return result;
};

const styles = theme => ({
  main: {
    backgroundColor: "#FAFAFA",
    // backgroundColor: "#fff",
    flex: 1,
    flexDirection: "row",
    minHeight: 300,
    paddingBottom: 35,
    paddingRight: "2%",
    paddingLeft: "2%",
    paddingTop: 35,
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap",
    justifyContent: "space-between"
  },
  bottomSection: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    flex: 1
  },
  leftSection: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    height: 350,
    alignItems: "center",
    justifyContent: "center"
  },
  rightSection: {
    flex: 1,
    height: 350,
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  accent: {
    color: "#6198DE"
  },
  bold: {
    fontWeight: 500,
    marginBottom: 15
  },
  actionLegend: {
    color: "#fff"
  },
  box: {
    webkitBoxShadow: "0px 0px 4px 1px #D8D8D8",
    mozBoxShadow: "0px 0px 4px 1px #D8D8D8",
    boxShadow: "0px 0px 4px 1px #D8D8D8",
    height: 200,
    flex: 1,
    padding: 5,
    flexDirection: "column",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
  },
  chartContainer: {
    backgroundColor: "blue",
    height: 350,
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
});

const isNumber = n => {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

class FeedbackSection extends PureComponent {
  state = {
    name: "",
    owner: "",
    domain: ""
  };

  componentDidMount = () => {
    // this.props.getActionListRequest();
  };

  onChangeClient = event => {
    this.props.changeCreateField({ name: event.target.value });
  };

  onChangeEmail = event => {
    this.props.changeCreateField({ owner: event.target.value });
  };

  onChangeDomain = event => {
    this.props.changeCreateField({ domain: event.target.value });
  };

  onSubmit = () => {
    this.props.createClientRequest({
      name: this.props.name,
      owner: this.props.owner,
      domain: this.props.domain
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.main}>
        {/* <Typography
          align="center"
          variant="h6"
          classes={{ root: classes.bold }}
        >
          Les Feedbacks
        </Typography> */}
        {/* <Feedback title="J'ai vraiment senti une meilleur cohésion d'équipe !" /> */}
        <Feedback title={this.props.bestComments[0]} />
        <Feedback title={this.props.bestComments[1]} />
        <Feedback title={this.props.bestComments[2]} />
        <Feedback title={this.props.bestComments[3]} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { isFakeData, fakeData } = state.admin;
  const { allActions, comments } = isFakeData ? fakeData : state.client;
  return {
    token: state.auth.token,
    bestComments: isFakeData ? comments : getBestComments(allActions)
  };
};

export default connect(
  mapStateToProps,
  {}
)(withStyles(styles)(FeedbackSection));
